module.exports = __webpack_public_path__ + "static/media/icon-how-it-works9.f78ebe9b.svg";